import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';
import { configureUsersAccessClient, UsersAccessScreen } from '@pay-roadrunner/users-access-ui';

configureUsersAccessClient({ authFetch, getApiBaseUrl });

export const UsersAccessPage = () => <UsersAccessScreen />;
